// 3rd Party
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
  Typography,
  IconButton,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// Asset Components
import arrowback from "../../assets/arrow_back.svg";

// Config
import { appConfig } from "../../config/appConfig";

// Asset Components

import edit from "../../assets/edit.svg";

// Components
import Spinner from "../../components/spinner/Spinner";

// Services
import {
  fetchSasUrl,
  logout,
  uploadToAzureBlob,
} from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// Styles (Own style)
import "./IndiaImage.scss";

interface Catgry {
  id: number;
  name: string;
}

type AdminEntry = {
  [x: string]: any;
  id: number;
  imageName: string;
  imageUrls: string | string[];
  isActive: boolean;
  status: string;
};

interface IndiaImageFormDialogProps {
  open: boolean;
  onClose?: () => void;

  fetchData: () => void;
  resetForm: () => void;

  categories: any;

  formData: AdminEntry;
  setFormData: React.Dispatch<React.SetStateAction<AdminEntry>>;
  editingIndex: any;
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
  setEditingIndex: React.Dispatch<React.SetStateAction<any>>;
  dataList: any;
}

const IndiaImageFormDialog: React.FC<IndiaImageFormDialogProps> = ({
  open,
  onClose,
  fetchData,
  resetForm,
  categories,
  formData,

  setFormData,
  editingIndex,
  setShowForm,
  setEditingIndex,
  dataList,
}) => {
  // useState
  const [selectedPdf, setSelectedPdf] = useState<File[]>([]);
  const [isActive, setIsActive] = useState(false);
  const [fileName, setfileName] = useState("No PDF");
  const [loading, setLoading] = useState(false);
  const [pdferror, setPdfError] = useState<string | null>(null);

  const [Imagepreview, setImagepreview] = useState<string>("No Image");

  // useNavigate
  const navigate = useNavigate();

  // Constants
  const MAX_FILE_SIZE_MB1 = 2;
  const ALLOWED_TYPE = ["image/jpeg", "image/jpg", "image/png"];

  useEffect(() => {
    setIsActive(formData.isActive);

    let temp: string[] = [];

    if (Array.isArray(formData.imageUrls)) {
      temp = formData.imageUrls.map((img) => img?.trim?.()).filter(Boolean);
    } else if (typeof formData.imageUrls === "string") {
      temp = formData.imageUrls
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean);
    }

    if (temp.length > 0) {
      const extractedFileName = temp[0].split("/").pop()?.trim() ?? "";

      setfileName(extractedFileName);
      setImagepreview(temp[0]);
    } else {
      setfileName(""); // clear filename fallback
      setImagepreview("");
    }
    if (selectedPdf && selectedPdf.length > 0) {
      setImagepreview(URL.createObjectURL(selectedPdf[0]));
    }
  }, [formData]);

  const handleCancel = () => {
    onClose?.();
    setShowForm(false);
    setEditingIndex(null);
    resetForm();
    setShowForm(false);
    setPdfError(null);
    setIsActive(false);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      //   [e.target.name]: e.target.value,
      imageName: e.target.value,
      lastUpdated: new Date().toISOString(),
    });
  };
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "application/pdf",
  ) => {
    if (e.target.files) {
      const filesArray = Array.from(e.target.files);
      if (type === "application/pdf") {
        setSelectedPdf(filesArray);
      }
    }
  };

  const handlePdfUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ? Array.from(e.target.files) : [];

    if (files.length === 0) {
      setPdfError("Please select a PDF file.");
      return;
    }

    const file = files[0]; // Assuming single file upload for PDF

    if (!ALLOWED_TYPE.includes(file.type)) {
      setPdfError("Only JPEG, JPG and PNG are allowed.");
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB1 * 1024 * 1024) {
      setPdfError("Image size must be less than or equal to 2MB.");
      return;
    }

    setPdfError(null);

    setSelectedPdf([file]);
    setImagepreview(URL.createObjectURL(file));
    // handleFileChange(e, "application/pdf"); //file.name
    setfileName(file.name);
  };

  // const uploadToBlob = async (file: File) => {
  //   let TokenUrl = await fetchSasUrl("file-uploads");
  //   let pathPrefix = "IndiaImages";
  //   let fileUrl = await uploadToAzureBlob(
  //     file,
  //     "file-uploads",
  //     TokenUrl,
  //     pathPrefix,
  //   );

  //   // alert(fileUrl);
  //   return fileUrl.split("?")[0];
  //   // return fileUrl.split("?")[0] + "/" + file.name;
  // };
  const uploadToBlob = async (file: File) => {
    try {
      let TokenUrl = await fetchSasUrl("file-uploads");
      let pathPrefix = "IndiaImages";
      let fileUrl = await uploadToAzureBlob(
        file,
        "file-uploads",
        TokenUrl,
        pathPrefix,
      );

      return fileUrl.split("?")[0];
    } catch (err) {
      console.error("Upload failed:", err);
      return "";
    }
  };

  const handleSave = async () => {
    if (!formData.categoryId?.toString()) {
      alert("Category is required!");
      return;
    }
    if (!formData.imageName) {
      alert("PDF Name is required!");
      return;
    }
    const currentCategoryId = formData.categoryId;

    const categoryItems = dataList.filter(
      (item: any) => item.categoryId === currentCategoryId,
    );
    if (categoryItems.length >= 4 && editingIndex === null) {
      alert("You can only add maximum 4 entries per category.");
      return;
    }
    if (formData.isActive) {
      const alreadyActive = categoryItems.find(
        (item: any) => item.isActive === true && item.id !== formData.id,
      );

      // if (alreadyActive) {
      //   alert("Only one active entry is allowed per category.");
      //   return;
      // }
    }
    const formDataToSend = new FormData();
    formDataToSend.append("id", editingIndex?.toString() ?? "0");
    formDataToSend.append("imageName", formData.imageName);
    formDataToSend.append("categoryId", formData.categoryId?.toString() ?? "0");
    formDataToSend.append("isActive", isActive.toString());
    formDataToSend.append("status", "Pending"); //Pending for Approval

    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("uploadBy", username);

    setLoading(true);
    try {
      const uploadedUrls: string[] = [];
      if (selectedPdf.length > 0) {
        const uploadPromises = selectedPdf.map(async (pdf) => {
          const fileUrl = await uploadToBlob(pdf);
          if (fileUrl) {
            formDataToSend.append("imageUrls", fileUrl);
            uploadedUrls.push(fileUrl);
          }
        });
        await Promise.all(uploadPromises);
      } else if (Array.isArray(formData.imageUrls)) {
        for (const url of formData.imageUrls) {
          const cleanUrl = typeof url === "string" ? url.trim() : "";
          if (cleanUrl && cleanUrl !== "null") {
            formDataToSend.append("imageUrls", cleanUrl);
            uploadedUrls.push(cleanUrl);
          }
        }
      } else if (typeof formData.imageUrls === "string" && formData.imageUrls.trim()) {
        const cleanUrl = formData.imageUrls.trim();
        if (cleanUrl !== "null") {
          formDataToSend.append("imageUrls", cleanUrl);
          uploadedUrls.push(cleanUrl);
        }
      }

      const url =
        editingIndex !== null
          ? `${appConfig.serviceUrls.saveIndiaImageEntries}/${formData.id}`
          : `${appConfig.serviceUrls.saveIndiaImageEntries}/upload`;

      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(url, {
        method: editingIndex !== null ? "PUT" : "POST",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        return;
      }
      if (!response.ok) throw new Error("Failed to save data");

      const { syncExtraCategoriesToBlob } = await import(
        "../../services/ExtraCategoriesSyncService"
      );
      syncExtraCategoriesToBlob();

      alert("Data saved successfully");
      fetchData();
      resetForm();
      const pdfInput = document.getElementById("pdfUpload") as HTMLInputElement | null;
      if (pdfInput) pdfInput.value = "";
      setSelectedPdf([]);
      setEditingIndex(null);
      setShowForm(false);
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save data");
    } finally {
      setLoading(false);
    }
    handleCancel();
  };
  const handleIsActive = () => {
    setIsActive(!isActive);
    setFormData({ ...formData, isActive: !isActive });
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "900px",
          height: "550px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F7F7F7",
          padding: "20px 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <IconButton
            color="primary"
            size="small"
            onClick={handleCancel}
            className="custom-icon-button"
          >
            <img src={arrowback} alt="visible" className="custom-icon" />
          </IconButton>
          <Typography className="custom-icon-text">
            {editingIndex !== null
              ? "Edit India Level Highlight"
              : "Add India Level Highlight"}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          background: "#FFF",
          padding: "50px 16px",
        }}
      >
        {loading ? (
          <>
            {" "}
            <Spinner></Spinner>
          </>
        ) : (
          <> </>
        )}
        {/* LEFT PANEL */}
        <Box className="left-panel">
          <Box className="thumbnail-frame">
            {Imagepreview ? (
              <img
                loading="lazy"
                src={Imagepreview}
                alt="New Thumbnail"
                width={205}
                height={205}
                style={{ objectFit: "contain" }}
              />
            ) : (
              <Typography>No Image</Typography>
            )}
          </Box>

          <Button className="edit-thumbnail" component="label">
            <img
              src={edit}
              alt="edit"
              style={{
                width: "20px",
                height: "20px",
                paddingRight: "5px",
              }}
            />

            <Typography className="edit-thumb-text">Edit Image</Typography>
            <input
              //   id="imageUpload"
              type="file"
              hidden
              accept="image/jpeg,image/png"
              onChange={handlePdfUpload}
            />
          </Button>
          {pdferror && <Alert severity="error">{pdferror}</Alert>}
          {/*  )} */}
        </Box>
        {/* Right pannel */}
        <Box>
          {/* select category */}
          <Box>
            <Typography className="state-text">
              Category<span className="star">*</span>
            </Typography>
            <Box sx={{ paddingBottom: "15px" }} />
            <TextField
              select
              // disabled={editingIndex !== null}
              label="Select Category"
              size="small"
              name="category"
              value={formData.categoryId}
              onChange={(e) =>
                setFormData({ ...formData, categoryId: e.target.value })
              }
              className="custom-select1"
            >
              {categories.map((cat: Catgry) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box>
            <Typography className="text-style">Image Name</Typography>
            <Box className="pdf-name-wrapper1">
              <TextField
                placeholder="Enter Image Name"
                size="small"
                name="imageName"
                value={formData.imageName}
                onChange={handleChange}
                variant="standard"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                }}
                inputProps={{
                  maxLength: 24,
                }}
              />
              <Typography className="pdf-char-count">
                {formData.imageName?.length || 0}/24
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography className="text-style">Active/Disable</Typography>

            <Box
              onClick={handleIsActive}
              sx={{ padding: "15px" }}
              className="status-wrapper"
            >
              <Box
                className={`status-toggle1 ${isActive ? "active" : "Disable"}`}
              >
                <Box className="status-circle" />
              </Box>

              <Typography
                sx={{ width: "30px" }}
                className="active-txt"
                component="span"
              >
                {isActive ? "Active" : "Disable"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <DialogActions>
        <Button
          onClick={handleCancel}
          className="cancel-button"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          disabled={pdferror != null}
          onClick={handleSave}
          className="submit-button"
        >
          {editingIndex !== null ? "Update" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IndiaImageFormDialog;
